export default __webpack_public_path__ + "static/Metal_Fence_Support-421ebcee0ea380720125d3cb65ee8139.png";